<template>
  <card class="no-border-card" body-classes="" footer-classes="pb-2">
    <!-- <template slot="header">
                        <div class="row align-items-center">
                            <div class="col-md-12 text-left">
                                <h2 class="mb-0">My Courses: (Expired/Failed courses can still be taken)</h2>
                            </div>
                        </div>
                    </template> -->


    <div class="row justify-content-sm-between flex-wrap location-form mb-4">
      <div class="col-md-6 col-lg-6 col-xl-7 d-flex align-items-center search-style">
        <h2 class="mb-0">Courses</h2>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-5 d-flex select-with-dynamic-class select-style mb-3 mb-md-0">
        <span>
          <div class="form-group">
            <label class="form-control-label"> Showing: </label>
            <div class="has-label">
              <div class="el-select select-primary pagination-select">
                <div class="el-input el-input--suffix">
                  <input type="text" readonly="readonly" autocomplete="off" placeholder="Per page"
                    class="el-input__inner">
                  <span class="el-input__suffix">
                    <span class="el-input__suffix-inner">
                      <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                    </span>
                  </span>
                </div>
                <div class="el-select-dropdown el-popper" style="display: none; min-width: 149.913px;">
                  <div class="el-scrollbar" style="">
                    <div class="el-select-dropdown__wrap el-scrollbar__wrap"
                      style="margin-bottom: -17px; margin-right: -17px;">
                      <ul class="el-scrollbar__view el-select-dropdown__list">
                        <li class="el-select-dropdown__item select-primary"><span>10</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>20</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>30</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>40</span></li>
                        <li class="el-select-dropdown__item select-primary selected"><span>50</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>100</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>150</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>200</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>300</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>400</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>500</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>600</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>700</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>800</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>900</span></li>
                        <li class="el-select-dropdown__item select-primary"><span>1000</span></li>
                      </ul>
                    </div>
                    <div class="el-scrollbar__bar is-horizontal">
                      <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                    </div>
                    <div class="el-scrollbar__bar is-vertical">
                      <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
        <div class="d-flex align-items-center select-style ml-3">
          <label class="mr-2 mb-0">Status:</label>
          <div class="el-select select-primary w-100">
            <div class="el-input el-input--suffix">
              <input type="text" readonly="readonly" autocomplete="off" placeholder="Filter by Location Status"
                name="Location Status Filter" class="el-input__inner">
              <span class="el-input__suffix"><span class="el-input__suffix-inner"><i
                    class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                </span>
              </span>
            </div>
            <div class="el-select-dropdown el-popper" style="display: none; min-width: 155.213px;">
              <div class="el-scrollbar" style="">
                <div class="el-select-dropdown__wrap el-scrollbar__wrap"
                  style="margin-bottom: -17px; margin-right: -17px;">
                  <ul class="el-scrollbar__view el-select-dropdown__list">
                    <li class="el-select-dropdown__item select-primary selected"><span>Active</span></li>
                    <li class="el-select-dropdown__item select-primary"><span>Inactive</span></li>
                    <li class="el-select-dropdown__item select-primary"><span>Show All</span></li>
                  </ul>
                </div>
                <div class="el-scrollbar__bar is-horizontal">
                  <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                </div>
                <div class="el-scrollbar__bar is-vertical">
                  <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <base-input label="Showing:">
                                    <el-select class="select-primary pagination-select" v-model="perPage"
                                        v-on:change="changePage(1)" placeholder="Per page">
                                        <el-option class="select-primary" v-for="item in perPageOptions" :key="item"
                                            :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </base-input>
                                <div class="d-flex align-items-center select-style ml-3">
                                <label class="mr-2 mb-0">Status:</label>
                                <el-select name="Location Status Filter" class="select-primary w-100"
                                    v-model="filters.locationStatus" placeholder="Filter by Location Status"
                                    v-on:change="fetchData()">
                                    <el-option class="select-primary" v-for="item in status" :key="item.value"
                                        :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </div> -->
      </div>
    </div>



    <div class="grid-action-boxes">
      <div class="row">
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>

                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>
                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>
                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="promotion-boxes-wrap mt-4 mb-4">
      <div class="row">
        <div class="col-md-6 mb-3 mb-md-0">
          <div class="action-box-promotion p-3 blue-box">
            <div class="row align-items-center">
              <div class="col-12 col-lg-7 col-xl-8 left">
                <h5 class="mb-1">Earn a Certificate</h5>
                <p>Get the right professional certificate program for you.</p>
                <base-button type="primary" class="px-3">
                  View Program
                </base-button>
              </div>
              <div class="d-none d-lg-block col-lg-5 col-xl-4 right text-right">
                <img src="/certificate_vector.svg">

              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="action-box-promotion p-3 orange-box">
            <div class="row align-items-center">
              <div class="col-12 col-lg-7 col-xl-8 left">
                <h5 class="mb-1">Best Rated Courses</h5>
                <p>Enroll now in the most popular and best rated courses.</p>
                <base-button type="primary" class="px-3">
                  View Courses
                </base-button>
              </div>
              <div class="d-none d-lg-block col-lg-5 col-xl-4 right text-right">
                <img src="/courses_vector.svg">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-action-boxes mb-4">
      <div class="row">
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>

                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>
                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="grid-wrap border rounded p-3">
            <img class="d-block mx-auto w-100 mb-3" src="/export-img.png">
            <div class="grid-header d-flex justify-content-between">
              <h5 class="mb-4">Active Shooter Training</h5>
              <span class="three-dots d-flex justify-content-between">
                <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z"
                    fill="#3B4056" />
                </svg>
              </span>
            </div>
            <div class="progress-area">
              <div class="progress-top-row mb-2 d-flex justify-content-between">
                <span class="time">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                      fill="#787878" />
                  </svg>
                  12 minutes
                </span>
                <span class="assigned">44</span>
              </div>
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar" style="width: 25%" aria-valuenow="25"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
            <div class="action-area d-flex justify-content-between">
              <base-button type="primary" outline="true" class="mr-2 px-4 opacitybtn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 6.99984C12.8334 3.77817 10.2217 1.1665 7.00002 1.1665C5.09178 1.1665 3.39755 2.08277 2.33329 3.49936L2.33335 2.0415H1.16669V5.5415H4.66669V4.37484L3.14098 4.37498C3.98096 3.14245 5.39598 2.33317 7.00002 2.33317C9.57736 2.33317 11.6667 4.42251 11.6667 6.99984C11.6667 9.57718 9.57736 11.6665 7.00002 11.6665C4.42269 11.6665 2.33335 9.57718 2.33335 6.99984H1.16669C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984ZM6.28684 4.96881L8.96935 6.75717C9.14249 6.87261 9.14249 7.12706 8.96935 7.2425L6.28678 9.03089C6.093 9.1601 5.83335 9.02115 5.83335 8.78816V5.21149C5.83335 4.97854 6.093 4.83959 6.28684 4.96881Z"
                    fill="#FE672C" />
                </svg>
                Start Over
              </base-button>
              <base-button type="primary" outline="true" class="px-4">
                Continue
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645L6.17157 0.464467C5.97631 0.269204 5.65973 0.269204 5.46447 0.464467C5.2692 0.659729 5.2692 0.976311 5.46447 1.17157L8.29289 4L5.46447 6.82843C5.2692 7.02369 5.2692 7.34027 5.46447 7.53553C5.65973 7.7308 5.97631 7.7308 6.17157 7.53553L9.35355 4.35355ZM-4.37114e-08 4.5L9 4.5L9 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#FE672C" />
                </svg>

              </base-button>

            </div>
          </div>
        </div>
      </div>
    </div>





    <div class="card-footer pt-1">
      <div data-v-77040714="" class="d-flex justify-content-end">
        <nav data-v-77040714="">
          <div data-v-77040714="" class="row">
            <div data-v-77040714="" class="col-md-12">
              <ul data-v-77040714="" class="pagination custompagination justify-content-end align-items-center">
                <p data-v-77040714="" class="p-0 m-0 mr-2">Showing 50 of 391 entries</p>
                <li data-v-77040714="" class="page-item disabled">
                  <a data-v-77040714="" href="#" class="page-link"><i data-v-77040714=""
                      class="fa fa-caret-left"></i></a>
                </li>
                <li data-v-77040714="" class="page-item active"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">1</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">2</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">3</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">4</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">5</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">6</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">7</a></li>
                <li data-v-77040714="" class="page-item"><a data-v-77040714="" href="javascript:void(0)"
                    class="page-link">8</a></li>
                <li data-v-77040714="" class="page-item">
                  <a data-v-77040714="" href="#" class="page-link"><i data-v-77040714=""
                      class="fa fa-caret-right"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>


  </card>
</template>
<script>
export default {
  name: "All-Courses"
}
</script>
